import { render, staticRenderFns } from "./scoreThesisList.vue?vue&type=template&id=6fd39982&scoped=true&"
import script from "./scoreThesisList.vue?vue&type=script&lang=js&"
export * from "./scoreThesisList.vue?vue&type=script&lang=js&"
import style0 from "./scoreThesisList.vue?vue&type=style&index=0&id=6fd39982&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd39982",
  null
  
)

export default component.exports